import styled from 'styled-components';
import { customTextColor } from '../../../../constants/CommonStyles';

export const H2B = styled.h3`
  font-weight: 600;
  font-size: 32px;
  line-height: 37px;
  ${customTextColor}
`;
